<template>
    <div class="stats-card">
        <h3>Overall Performance</h3>
        <div class="stats-grid">
            <div class="stat-item">
                <span class="stat-label">Total Attempts</span>
                <span class="stat-value">{{ analytics.total_attempts }}</span>
            </div>
            <div class="stat-item">
                <span class="stat-label">Accuracy</span>
                <span class="stat-value">{{ analytics.overall_accuracy.toFixed(1) }}%</span>
            </div>
            <div class="stat-item">
                <span class="stat-label">Average Score</span>
                <span class="stat-value">{{ analytics.average_score.toFixed(2) }}</span>
            </div>
            <div class="stat-item">
                <span class="stat-label">Questions Attempted</span>
                <span class="stat-value">{{ analytics.total_questions_attempted }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnalyticsStats',
    props: {
        analytics: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped>
.stats-card {
    background: var(--bg-secondary);
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    transition: border-color 0.3s;
}

.stats-card:hover {
    border-color: var(--accent);
}

.stats-card h3 {
    margin: 0 0 20px 0;
    color: var(--text-secondary);
    font-size: 24px;
    letter-spacing: 2px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
}

.stat-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 20px;
    background: var(--bg-primary);
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    transition: all 0.3s;
}

.stat-item:hover {
    background: var(--bg-secondary);
    border-color: var(--accent);
    transform: translateY(-2px);
}

.stat-label {
    color: var(--text-primary);
    font-size: 14px;
    opacity: 0.8;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.stat-value {
    color: var(--text-secondary);
    font-size: 36px;
    font-weight: 700;
}
</style>